import { round } from "lodash-es";
import { useTranslation } from "react-i18next";
import { CUBE_SIDE_NAMES } from "../../FuturebilityCockpit/components/Сube/constants";
import { CubeSideName } from "../../FuturebilityCockpit/components/Сube/types";
import { CubeSideData } from "../../FuturebilityCockpit/hooks/useCategoryPageData/types";
import { BottomBar } from "../../ParticipationFlow/components/bottom-bar";

function ItemsPage({
  cubeSides,
}: {
  cubeSides: Record<CubeSideName, CubeSideData>;
}) {
  const { t } = useTranslation();
  return (
    <>
      {CUBE_SIDE_NAMES.map(
        (side, index) =>
          cubeSides[side].itemizedAverageScoreData.length > 0 && (
            <div className="page page-items" key={index}>
              <div className="content">
                <div className="content-header">
                  <div className="title">
                    {t("individualPdfReport.items", "Items")}
                  </div>
                  <div className="subtitle">
                    {cubeSides[side].title ?? side}
                  </div>
                </div>

                <div className="items-list">
                  {cubeSides[side].itemizedAverageScoreData.map((item, i) => (
                    <div key={i} className="score-item">
                      <span className="question">{item.questionTitle}</span>
                      <span className="score">{round(item.averageScore)}%</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="footer">
                <BottomBar />
              </div>
            </div>
          )
      )}
    </>
  );
}

export default ItemsPage;
